<template>
  <div>
    <v-card :disabled="isProcessing" :loading="isProcessing">
      <template v-slot:progress>
        <v-progress-linear
          absolute
          color="success"
          height="4"
          indeterminate
        ></v-progress-linear>
      </template>
      <v-tabs
        v-model="tab"
        class="deep-gl"
        left
        dark
        icons-and-text
      >
        <v-tabs-slider></v-tabs-slider>

        <v-tab href="#tab-1">
          <v-toolbar-title> {{name}}/Team Members  </v-toolbar-title>
        </v-tab>
        <v-tab href="#tab-2">
          <v-toolbar-title> Access & Visibility  </v-toolbar-title>
        </v-tab>
        <v-spacer></v-spacer>

        <div class="buttons-tab"></div>
      </v-tabs>

            <v-form
                @submit.prevent
                ref="requestData"
                v-model="validRequestData"
              >
      <v-tabs-items v-model="tab">
           <template v-slot:progress>
              <v-progress-linear
                absolute
                color="success"
                height="4"
                indeterminate
              ></v-progress-linear>
            </template>
        <v-tab-item value="tab-1">
          <v-card flat>
            <v-card-text>

                <v-row>
                  <v-col cols="12" sm="12">
                    <v-text-field v-model="requestData.name" @change="setChange" label="Name*" required  :rules="[validations.required()]"></v-text-field>
                  </v-col>
                </v-row>
                <v-row>
                    <v-col lg="12" cols="12">
                        <v-simple-table>
                            <template v-slot:default>
                                <thead>
                                    <tr>
                                        <th v-for="(header,i) in usersTableHeaders" :key="i" class="text-left">
                                            {{header}}
                                        </th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr
                                        v-for="(user,i) in requestData.users"
                                        :key="i"
                                    >
                                            <td width="50%" class="vertical-middle"><strong>{{user.name}}</strong><br><span>{{user.email}}</span></td>

                                            <td width="30%">
                                                <v-checkbox color="primary" @change="onChange" v-model="user.is_manager"></v-checkbox>
                                            </td>
                                            <td width="20%">
                                                <v-btn class="mt-4" text color="primary" v-on:click="requestData.users.splice(i,1)"><v-icon>mdi-delete</v-icon></v-btn>
                                            </td>
                                    </tr>
                                </tbody>
                            </template>
                        </v-simple-table>
                    </v-col>
                </v-row>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <AddMember @member="addMember"></AddMember>
              <v-btn color="warning" v-on:click="back(true)">Back</v-btn>
              <v-btn color="success" v-if="hasPermissions(type === 'Create'?'teams-create':'teams-edit')" v-on:click="store()">{{type}}</v-btn>
            </v-card-actions>
          </v-card>
        </v-tab-item>
        <v-tab-item value="tab-2">
          <v-card flat>
            <v-card-text>
                <v-row>
                  <v-col lg="12" cols="12">
                            <v-simple-table class="access-table">
                                <template v-slot:default>
                                <thead>
                                    <tr>
                                        <th
                                          v-for="(header, headerIndex) in tableHeaders"
                                          :key="headerIndex"
                                          class="text-left"
                                          :style="{ width: header.width }"
                                        >
                                            {{ header.text }}
                                        </th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr
                                        v-for="(permission, group) in permissions"
                                        :key="group"
                                    >
                                            <td class="vertical-middle">
                                              {{ permissionGroupLabel(group) }}
                                              <template v-if="['live-list', 'price-lists'].includes(group)">
                                              <br /><div class="text-warning">({{ $t('TEAMS.NEED_OFFERS_PERRMISSION_WARNING') }})</div>
                                              </template>
                                            </td>

                                            <td>
                                                 <v-checkbox
                                                    color="primary"
                                                    v-model="access[group]"
                                                    @change="setAccess($event, group)"
                                                 ></v-checkbox>
                                            </td>
                                            <td v-for="suffix in actionSuffixes" :key="`${group}${suffix}`">
                                                 <v-checkbox
                                                    v-if="actionPermission(permission, group, suffix)"
                                                    color="primary"
                                                    v-model="requestData.permissions[group + actionPermission(permission, group, suffix).id]"
                                                    :value="actionPermission(permission, group, suffix).id"
                                                    :disabled="!access[group]"
                                                    :key="`${inputChange}-${group}${suffix}`"
                                                    @change="onChange"
                                                 ></v-checkbox>
                                            </td>
                                            <td>
                                                 <v-select
                                                    v-if="viewPermissions(permission).length"
                                                    :items="viewPermissions(permission)"
                                                    item-text="text"
                                                    item-value="id"
                                                    v-model="requestData.permissions[group + 'View']"
                                                    :disabled="!access[group]"
                                                    @change="onChange"
                                                    :key="`${inputChange}-${group}-view`"
                                                ></v-select>
                                            </td>
                                            <td>
                                                 <v-select
                                                    v-if="group === 'deals'"
                                                    v-model="requestData.organization_ids"
                                                    :items="organizationOptions"
                                                    item-text="label"
                                                    item-value="id"
                                                    multiple
                                                    chips
                                                    small-chips
                                                    deletable-chips
                                                    clearable
                                                    :disabled="!access[group]"
                                                    placeholder="All organizations"
                                                    @change="onChange"
                                                 ></v-select>
                                            </td>
                                    </tr>
                                </tbody>
                                </template>
                            </v-simple-table>
                  </v-col>
                </v-row>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="warning" v-on:click="back(true)">Back</v-btn>
              <v-btn color="success" v-on:click="store()">{{type}}</v-btn>
            </v-card-actions>
          </v-card>
        </v-tab-item>
      </v-tabs-items>
       </v-form>
    </v-card>
     <TPConfirm
            v-model="showConfirmSet"
            content="All current changes will be lost."
            @confirm="back"
        ></TPConfirm>
  </div>
</template>

<script>

import { mapGetters } from "vuex";
import validations from "@/views/partials/form/Validations.vue";
import { GET_TEAM_PERMISSIONS_REQUEST,GET_TEAM_REQUEST,CREATE_TEAM_REQUEST,UPDATE_TEAM_REQUEST } from "@/store/teams.module";
import { GET_ORGANIZATIONS_OPTIONS } from "@/store/organizations.module";
import { SHOW_SNACK } from "@/store/snack.module";
import AddMember from "./partials/AddMember.vue";
import TPConfirm from "@/views/partials/dialogs/Confirm.vue";

export default {
  name: "StoreTeam",
  components: {
      AddMember,
      TPConfirm
  },
  data() {
    return {
      name: "Create Team",
      validations: validations,
      validRequestData: false,
      tab: "tab-1",
      tableHeaders: [
        { text: "Entity Type", width: "18%" },
        { text: "Access", width: "10%" },
        { text: "Create", width: "10%" },
        { text: "Edit", width: "10%" },
        { text: "Delete", width: "10%" },
        { text: "Member of this team can see", width: "26%" },
        { text: "Organizations", width: "16%" },
      ],
      actionSuffixes: ["-create", "-edit", "-delete"],
      usersTableHeaders: ['Name','Team Manager',''],
      isProcessing: false,
      requestData: {"permissions":{},"users":[],"organization_ids":[]},
      organizationOptions: [],
      permissions: [],
      showNewTeam: false,
      showNewRole: false,
      changePassword: false,
      newTeamButtonShow:true,
      type:"Create",
      inputChange:0,
      hasChanges:false,
      showConfirmSet:false,
      item:{},
      access: {}
    };
  },
    computed: {
        ...mapGetters(["roles"]),
    },
  mounted() {
     this.selectTeam();
     this.loadOrganizations();
  },
  methods: {

    store() {
      this.$refs.requestData.validate();

      if (!this.validRequestData) {
        return;
      }

      let url = CREATE_TEAM_REQUEST;
      let params = this.requestData;
      if(this.$route.params.id){
         url = UPDATE_TEAM_REQUEST;
         params = {id:this.$route.params.id,params:this.requestData};
      }

      this.isProcessing = true;
      this.$store.dispatch(url,params).then(() => {
          this.$store.dispatch(SHOW_SNACK, {
            message: "Team stored successfuly.",
          });
          this.reloadCurrentUser();
           this.$router.push({
                name: "teams",
            });
        }).catch((error) => {

        })
        .finally(() => {
          this.isProcessing = false;
          this.$refs.requestData.resetValidation();
        });
    },
    showTeam() {
      this.requestData.teams.push({
          "id":null,
          "is_manager":0
      });
      this.showTeamButton()
    },
    showTeamButton(){
        this.newTeamButtonShow = this.requestData.teams.length < this.teams.length
    },
    setAccess(event, type) {
      this.hasChanges = true;

      if (event) {
        const viewAll = this.permissions[type].find((item) => item.name === `${type}-view-all`);

        if (viewAll) {
          this.requestData.permissions[`${type}View`] = viewAll.id;
        }

        this.access[type] = true;
      } else {
        Object.keys(this.requestData.permissions).forEach((key) => {
          if (this.permissionKeyBelongsToGroup(key, type)) {
            delete this.requestData.permissions[key];
          }
        });
        this.access[type] = false;

        if (type === "deals") {
          this.requestData.organization_ids = [];
        }
      }

      this.inputChange++;
    },
    permissionKeyBelongsToGroup(key, group) {
      if (key === `${group}View`) {
        return true;
      }

      return key.startsWith(group) && /^\d+$/.test(key.slice(group.length));
    },
    permissionGroupLabel(group) {
      if (group === "deal-completed") {
        return "Completed Deals";
      }

      if (group === "deals-owners") {
        return "Deals Owners";
      }

      return group.charAt(0).toUpperCase() + group.slice(1);
    },
    actionPermission(permissions, group, suffix) {
      const expectedName = group === "deal-completed" && suffix === "-edit"
        ? "deals-completed-edit"
        : `${group}${suffix}`;

      return permissions.find((item) => item.type === 0 && item.name === expectedName) || null;
    },
    viewPermissions(permissions) {
      return permissions.filter((item) => item.type === 1);
    },
    orderPermissionGroups(permissions) {
      const entries = Object.entries(permissions || {});
      const moveAfterDeals = (group) => {
        const index = entries.findIndex(([key]) => key === group);

        if (index === -1) {
          return;
        }

        const [item] = entries.splice(index, 1);
        const dealsIndex = entries.findIndex(([key]) => key === "deals");
        entries.splice(dealsIndex === -1 ? entries.length : dealsIndex + 1, 0, item);
      };

      moveAfterDeals("deal-completed");
      moveAfterDeals("deals-owners");

      return entries.reduce((groups, [key, value]) => {
        groups[key] = value;
        return groups;
      }, {});
    },
     setChange(){
        this.hasChanges = true;
    },
    onChange(event){
        this.hasChanges = true;
    },
    back(check) {
      if(check && this.hasChanges){
          this.showConfirmSet = true;
      }else{
          this.hasChanges = false;
          this.$router.push({ name: "teams" });
      }
    },
    setInitialRequestData() {
      this.requestData = {
        "permissions":{},
        "users":[],
        "organization_ids":[]
      };
    },
    addMember(event){
        if(this.requestData.users.indexOf(event) === -1){
            this.requestData.users.push(event);
        }
        this.setChange()
    },
    selectTeam(){
        if(this.$route.params.id){
             this.name = "Update Team";
             this.type = "Update";
             this.isProcessing = true;
             this.$store.dispatch(GET_TEAM_REQUEST,this.$route.params.id).then((response) => {
                this.requestData = response;
                this.requestData.organization_ids = Array.isArray(response.organization_ids)
                  ? response.organization_ids.map((id) => Number(id))
                  : [];
                this.access = this.requestData.groups;
                 this.getPermissions();
            }).catch((error) => {
                  this.handleException(error)
            }).finally(() => {
                this.isProcessing = false;
            });
        }else{
            this.getPermissions()
        }
    },
    getPermissions(){
         this.$store.dispatch(GET_TEAM_PERMISSIONS_REQUEST).then(response => {
                this.permissions = this.orderPermissionGroups(response.data);
         })
    },
    loadOrganizations() {
      this.$store.dispatch(GET_ORGANIZATIONS_OPTIONS, {}).then((response) => {
        this.organizationOptions = Array.isArray(response?.data) ? response.data : [];
      }).catch(() => {
        this.organizationOptions = [];
      });
    }
  },
};
</script>
<style lang="sass" scoped>
.privileges
    margin-top: 50px
    .v-input--checkbox
        margin-top: 10px
        ::v-deep label
            margin-bottom: 0px!important
    h1
        font-size: 16px
        font-weight: bold
    .prev-info
        margin-left: 32px

.access-table
    ::v-deep table
        table-layout: fixed
        width: 100%
    ::v-deep td
        vertical-align: middle
    ::v-deep .v-input--checkbox
        margin-top: 0
        padding-top: 0
    ::v-deep .v-input--selection-controls
        margin-top: 0
        padding-top: 0
</style>